<script>
import { apiSecond } from '@/boot/axios'

export default {
	name: 'EASUCheck',
	data() {
		return {
			iin_bin: '',
			nikad: '',
			loading: false,
			result: null,
			errorMessage: {
				status: null,
				messages: null,
				text: null,
			},
		}
	},
	methods: {
		async onSubmit() {
			this.errorMessage = { status: null, messages: null, text: null }
			this.result = null
			this.loading = true
			try {
				const response = await apiSecond.get(
					`https://api.efish.kz/api/v1/integrations/monitoring/check?iin_bin=${encodeURIComponent(
						this.iin_bin,
					)}&nikad=${encodeURIComponent(this.nikad)}`,
				)
				this.result = response.data
			} catch (error) {
				if (
					error?.response?.status === 404 &&
					error?.response?.data?.error === 'Данные не найдены'
				) {
					this.errorMessage.status = 404
					this.errorMessage.text = 'Данные не найдены'
				} else if (error?.response?.status === 500) {
					this.errorMessage.status = 500
					this.errorMessage.text = this.$t('system_message.500')
				} else if (error?.response?.status === 401) {
					this.errorMessage.status = 401
					this.errorMessage.text = error.response.data.error_message
					this.$router.push('/' + this.$i18n.locale + '/login')
				} else if (error?.response?.status === 422) {
					this.errorMessage.status = 422
					this.errorMessage.text = error.response.data.error_message
					this.errorMessage.messages = error.response.data.error_messages
				} else {
					this.errorMessage.status = error?.response?.status || 400
					this.errorMessage.text = error?.response?.data?.error_message || error.message
				}
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<template>
	<div class="wrap__content">
		<div class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['IntegrationPanel', 'EASUCheck']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--text">{{ $t('sidebar.easu_check') }}</div>
								</div>
							</div>
							<div class="card__content--body">
								<form method="GET" @submit.prevent="onSubmit">
									<div class="form__line">
										<div class="form__line--left">
											<div class="form__line--title">{{ $t('headers.iin_bin') }}</div>
										</div>
										<div class="form__line--right">
											<div class="row">
												<div class="col-xl-5">
													<div class="form__line--input">
														<input
															v-model="iin_bin"
															type="text"
															class="input-linck"
															required
															name="iin_bin"
															:placeholder="$t('headers.iin_bin')"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="form__line">
										<div class="form__line--left">
											<div class="form__line--title">{{ $t('headers.nikad') }}</div>
										</div>
										<div class="form__line--right">
											<div class="row">
												<div class="col-xl-5">
													<div class="form__line--input">
														<input
															v-model="nikad"
															type="text"
															class="input-linck"
															required
															name="nikad"
															:placeholder="$t('headers.nikad')"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="form__line">
										<div class="form__line--left"></div>
										<div class="form__line--right">
											<button class="input-btn form__line--btn" :disabled="loading">
												<span v-if="!loading">{{ $t('button.find') }}</span>
												<span v-else>{{ $t('button.find') }}...</span>
											</button>
										</div>
									</div>
								</form>
								<div
									v-if="errorMessage.text"
									class="form__block--line form__messages"
									:class="{
										'form__messages--error': errorMessage.status != 200,
										'form__messages--success': errorMessage.status == 200,
									}"
								>
									<label class="form__block--input">
										<span class="form__block--title">{{ errorMessage.text }}</span>
									</label>
								</div>
								<div v-if="result" class="table__block--content mt-4">
									<div class="card__content mt-3">
										<div class="card__content-header">
											<div class="content__title--text">
												{{ $t('sidebar.easu_check') }}: {{ result.nikad }}
											</div>
										</div>
										<div class="card__content--body">
											<div class="row mb-2">
												<div class="col-md-6">
													<b>{{ $t('headers.iin_bin') }}:</b> {{ result.bin }}<br />
													<b>{{ $t('headers.nikad') }}:</b> {{ result.nikad }}<br />
													<b>{{ $t('headers.status') }}:</b> {{ result.status }}<br />
													<b>{{ $t('headers.created_at') }}:</b> {{ result.created_at | formatDate
													}}<br />
													<b>{{ $t('headers.updated_at') }}:</b> {{ result.updated_at | formatDate
													}}<br />
												</div>
												<div class="col-md-6">
													<!-- <b>{{ $t('headers.table_name') }}:</b> {{ result.source_table }}<br /> -->
													<b>{{ $t('headers.unac_id') }}:</b> {{ result.unac_id }}
												</div>
											</div>
											<div v-if="result.fishes && result.fishes.length">
												<h5 class="mt-3 mb-2">{{ $t('components.fish') }}</h5>
												<div
													class="v-data-table table__analytic v-data-table--has-bottom theme--light"
												>
													<div class="v-data-table__wrapper">
														<table>
															<thead class="v-data-table-header">
																<tr>
																	<th>{{ $t('headers.number') }}</th>
																	<th>{{ $t('headers.name') }}</th>
																	<th>{{ $t('headers.total') }}</th>
																	<th>{{ $t('headers.requested_size') }}</th>
																	<th>{{ $t('headers.available_volume') }}</th>
																</tr>
															</thead>
															<tbody>
																<tr v-for="fish in result.fishes" :key="fish.fish_id">
																	<td>{{ fish.fish_id }}</td>
																	<td>{{ fish.fish_name }}</td>
																	<td>{{ fish.total_size }}</td>
																	<td>{{ fish.requested_size }}</td>
																	<td>{{ fish.available_size }}</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
											<div v-if="result.requests && result.requests.length">
												<h5 class="mt-3 mb-2">{{ $t('labels.requests') }}</h5>
												<div
													class="v-data-table table__analytic v-data-table--has-bottom theme--light"
												>
													<div class="v-data-table__wrapper">
														<table>
															<thead class="v-data-table-header">
																<tr>
																	<th>{{ $t('headers.reference_nikad') }}</th>
																	<th>{{ $t('headers.status') }}</th>
																	<th>{{ $t('headers.type') }}</th>
																	<th>{{ $t('headers.created_at') }}</th>
																	<th>{{ $t('components.fish') }}</th>
																</tr>
															</thead>
															<tbody>
																<tr v-for="req in result.requests" :key="req.reference_nikad">
																	<td>{{ req.reference_nikad }}</td>
																	<td>{{ req.status }}</td>
																	<td>{{ req.type }}</td>
																	<td>{{ req.created_at | formatDate }}</td>
																	<td>
																		<div v-for="fish in req.fishes" :key="fish.fish_id">
																			{{ $t('headers.fish') }} {{ fish.fish_id }}:
																			{{ $t('headers.volume') }} {{ fish.size }}
																		</div>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.mt-3 {
	margin-top: 1rem;
}
.mt-4 {
	margin-top: 1.5rem;
}
.mb-2 {
	margin-bottom: 0.5rem;
}
</style>
